import { Pie, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

const { reactiveProp } = mixins
export default {
  name: 'PieChart',
  mixins: [Pie, reactiveProp],
  components: { ChartDataLabels },
  props: ['chartData'],
  data() {
    return {
      position: 'right',
      fontSize: 11,
      labelFontSize: 13,
      padding: 10,
      lastWidth: 0,
    }
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        fullWidth: false,
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          position: this.position,
          fullWidth: false,
          itemWidth: 500,
          labels: {
            fontColor: 'black',
            usePointStyle: true,
            fontSize: this.fontSize,
            padding: this.padding,
          },
          onClick: null,
        },
        tooltips: {
          enabled: false,
        },
        plugins: {
          datalabels: {
            color(context) {
              return context.dataIndex < 1 ? 'black' : 'white'
            },
            textAlign: 'center',
            font: {
              size: this.labelFontSize,
              weight: 'bold',
              lineHeight: 1.6,
            },
            formatter(value) {
              return `${value}%`
            },
          },
        },
      }
    },
  },
  methods: {
    setAspectRatioProps() {
      this.position = 'right'
      this.fontSize = 11
      this.padding = 10
      const width = window.innerWidth
      const height = window.innerHeight
      if (width < 1280 && width > 897) {
        this.position = 'bottom'
        this.fontSize = (width < 1100 || height < 700) ? 7 : 9
        this.padding = 3
        this.labelFontSize = height < 600 ? 6 : 9
        if (width < 1100) this.padding = 5
      } else if (width > 1900) {
        this.fontSize = 16
      }
    },
    updateProp() {
      const { innerWidth } = window

      if (innerWidth === this.lastWidth) return

      this.setAspectRatioProps()
      /* eslint-disable no-underscore-dangle */
      this.$data._chart.destroy()
      this.renderChart(this.chartData, this.options)

      this.lastWidth = innerWidth
    },
    init() {
      this.setAspectRatioProps()
      this.renderChart(this.chartData, this.options)
      window.addEventListener('resize', () => { this.updateProp() })
    },
  },
  mounted() {
    this.init()
  },
}
